export default "__VITE_PUBLIC_ASSET__67cac2b2__"